import { Link } from "react-router-dom";
import { articles, hotTopics } from "@/mocks/news";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-600",
  down: "ri-arrow-down-line text-accent-600",
  flat: "ri-subtract-line text-foreground-400",
};

interface HotSidebarProps {
  excludeId?: string;
}

export default function HotSidebar({ excludeId }: HotSidebarProps) {
  const ranked = articles
    .filter((item) => item.id !== excludeId)
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 8);

  return (
    <aside className="space-y-6">
      <section
        id="hot-topic"
        className="rounded-lg border border-background-200 bg-background-50 p-5"
        aria-labelledby="hot-list-title"
      >
        <div className="flex items-center justify-between">
          <h2 id="hot-list-title" className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-fire-line text-lg text-primary-600" aria-hidden="true"></i>
            实时热榜
          </h2>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            每 15 分钟刷新
          </span>
        </div>
        <ol className="mt-4 space-y-1">
          {ranked.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/article/${item.id}`}
                className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
              >
                <span
                  className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0">
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </span>
                  <span className="mt-1 block text-xs text-foreground-500">
                    {item.category} · {item.timeLabel}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      <section
        className="rounded-lg border border-background-200 bg-secondary-50 p-5"
        aria-labelledby="topic-title"
      >
        <h2 id="topic-title" className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-flashlight-line text-lg text-secondary-700" aria-hidden="true"></i>
          话题热度榜
        </h2>
        <ul className="mt-4 space-y-3">
          {hotTopics.map((topic) => (
            <li key={topic.label} className="flex items-center justify-between gap-3">
              <span className="min-w-0">
                <span className="block truncate text-sm font-medium text-foreground-900">
                  {topic.label}
                </span>
                <span className="text-xs text-foreground-500">{topic.keyword}</span>
              </span>
              <span className="flex shrink-0 items-center gap-1.5">
                <span className="text-sm font-bold text-foreground-800">{topic.heat}</span>
                <i className={`${trendIcon[topic.trend]} text-sm`} aria-hidden="true"></i>
              </span>
            </li>
          ))}
        </ul>
      </section>
    </aside>
  );
}